import { render, staticRenderFns } from "./AlterarFundo.vue?vue&type=template&id=0e4eee16&scoped=true&"
import script from "./AlterarFundo.vue?vue&type=script&lang=ts&"
export * from "./AlterarFundo.vue?vue&type=script&lang=ts&"
import style0 from "./AlterarFundo.vue?vue&type=style&index=0&id=0e4eee16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4eee16",
  null
  
)

export default component.exports